import { PatchBorder } from "../GameObjects/PatchBorder";
import * as QuiltUtils from "../Utils/QuiltUtils";

export class PatchTile extends PIXI.Container {
    private _borders: PatchBorder[];
    private _obscured: boolean;

    constructor() {
        super();
        this._obscured = false;
        this._borders = new Array<PatchBorder>(QuiltUtils.Direction.NUM_ELEMENTS);
    }

    public get obscured(): boolean {
        return this._obscured;
    }

    public set obscured(pValue) {
        this._obscured = pValue;
        if (this._obscured === true) {
            this.hideStitches();
        }
    }

    public addBorder(pDir: QuiltUtils.Direction): void {
        if (this._borders[pDir] === undefined) {
            this._borders[pDir] = new PatchBorder(pDir);
            this.addChild(this._borders[pDir]);
        }
    }

    public showStitches(pExcept: QuiltUtils.Direction[]): void {
        for (let dir = 0; dir < QuiltUtils.Direction.NUM_ELEMENTS; ++dir) {
            if (this._borders[dir] !== undefined && pExcept.indexOf(dir) === -1) {
                this._borders[dir].showStitches();
            }
        }
    }

    public hideStitches(pDir?: QuiltUtils.Direction): void {
        if (pDir === undefined) {
            for (let i = 0; i < this._borders.length; ++i) {
                if (this._borders[i] !== undefined) {
                    this._borders[i].hideStitches();
                }
            }
        }
        else if (this._borders[pDir] !== undefined) {
            this._borders[pDir].hideStitches();
        }
    }
}
